import { Box, Button, Typography, Stack, Divider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import packageJson from "../../../package.json"
// import { Text } from "../../SystemDesign/Styles";
import digitalIALogo from "../../Assets/digital_ia_logo-removebg-preview.png";


export default function DrawerFooter({ open }) {
    //call the theme
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    // Style for the footer container - without any scroll/overflow properties
    const footerStyle = {
        display: open ? "flex" : "none",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "100%",
        color: colors.grey[700],
        padding: "0.5rem",
        marginTop: "auto",
        boxSizing: "border-box"
    };
    
    return (
        <div style={footerStyle}>
        <Stack direction="column" spacing={1} alignItems="center" justifyContent="center">
            <Typography 
                textAlign={"center"} 
                sx={{ 
                    mb: 1, 
                    maxWidth: "100%"
                }}
            >
                Version {packageJson.version}
            </Typography>
            
            <Stack 
                direction="row" 
                spacing={1} 
                alignItems="center" 
                justifyContent="center"
                sx={{ 
                    mb: 1,
                    maxWidth: "100%"
                }}
            >
                <img 
                    src={digitalIALogo} 
                    alt="Digital IA" 
                    style={{ 
                        width: "25px", 
                        height: "25px" 
                    }} 
                />
                <Typography 
                    variant="caption" 
                    sx={{ 
                        fontSize: "0.7rem",
                        maxWidth: "calc(100% - 30px)"
                    }}
                >
                    © {new Date().getFullYear()} Developed by Digitalia
                </Typography>
            </Stack>
            </Stack>
        </div>
    );
}
